import { Component, ViewChild, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { DialogRef, ModalComponent, overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AlertPopupComponent } from '../../../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { PromotionalcodeserviceService } from '../../../../_services/sharedpromotionalcode/promotionalcodeservice.service';
import { AlertService } from '../../../commonservice/alert.service';
import { utilityService } from '../../../commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../../_common/constants/app.constants';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-email-list',
  templateUrl: './email-list.component.html',
  styleUrls: ['./email-list.component.css'],
  providers: [PromotionalcodeserviceService, utilityService]
})
export class EmailListComponent implements ModalComponent<CustomModalContext>, OnInit {
  context: CustomModalContext;
  mailList: any = [];
  email;
  inProgress = false;
  appSettings;

  @ViewChild(NgForm)
  myForm: NgForm;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private sharePromotionCode: PromotionalcodeserviceService,
    public translate: TranslateService,
    public modal: Modal,
    public utilserv: utilityService,
    private alertService: AlertService
  ) {
    this.context = dialog.context;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {
    this.appSettings = AppSettings;
  }

  addEmailToList() {
    const isExist = this.mailList.indexOf(this.email);
    if (this.mailList.length > 0 && isExist !== -1) {
      const modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblOops').toString();
      modalData.Message = this.translate.instant('Message_emailExist');
      modalData.Action = this.translate.instant('Common_lblOk');
      this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    } else {
      this.mailList.push(this.email);
    }
    // const selectedelement = <HTMLInputElement> document.getElementById('txtEmail');
    // selectedelement.value= null;
    this.email = '';
    this.myForm.resetForm();
  }
  deletemail(e) {
    const filteremailList = this.mailList.filter(email => email != e);
    this.mailList = [];
    this.mailList = filteremailList;
  }
  closeClick() {
    this.dialog.close();
  }
  sendEmail() {
    this.inProgress = true;
    const mailObject: any = {};
    mailObject.emailList = this.mailList;
    mailObject.RefralCode = this.context.modalData.referralCode;
    mailObject.RefralLink = this.context.modalData.sharedURL;
    if (this.mailList.length > 0) {
      this.utilserv.busy = this.sharePromotionCode.sendPromotionalCodeEmailService(mailObject).subscribe(
        data => {
          this.inProgress = false;
          if (data.Envelope.Body.ShareRefralResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
            return false;
          } else if (data.Envelope.Body.ShareRefralResponse.StatusCode == -10000) {
            this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
          } else if (data.Envelope.Body.ShareRefralResponse.StatusCode == enumStatusCodeList.SUCCESS) {
            this.alertService.openErrorAlert(this.translate.instant('Common_lblThankyou'), this.translate.instant('SharePopup_descSuccessShare'));
            this.closeClick();
          }
        },
        error => {
          console.log('Unable to sendPromotionalCodeEmailService' + error);
        }
      );
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('SharePopup_desc'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/sharepromotionalcode/email/email-list/email-list.component.ts